'use client';

import React from 'react';
import { GTMConversionEvent } from 'app/types/google-tag-manager/gtmConversionEvent';
import { GTMEEPCEvent } from 'app/types/google-tag-manager/gtmEEPCEvent';

type Props = {
  gtmConversionEvent: GTMConversionEvent;
  gtmEEPCEvent: GTMEEPCEvent | undefined;
};

const InitializeGtm: React.FC<Props> = ({
  gtmConversionEvent,
  gtmEEPCEvent,
}): JSX.Element | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  window.dataLayer = window.dataLayer ?? [];

  // This is initialized in globalMarkup using COIN in the legacy application. I do not know if this is required, but adding for backwards-compatiblity sake.
  // See https://github.com/NerdWallet/global-markup/blob/master/html-integrations/google-tag-manager.html
  window.dataLayer.push({
    gtmPageVertical: '',
    gtmQuantcastLabel: 'Vertical.',
    gtmPageTopic: '',
    gtmPageType: 'Decide',
    gtmContentType: '',
    gtmContentClusters: '',
    isNWMobileApp: 'false',
    isLoggedIn: 'false',
    gtmAttrVertical: '',
    gtmAttrTopic: '',
    gtmPrimaryCluster: '',
  });

  window.dataLayer.push({
    event: gtmConversionEvent.event,
    gtmReferPath: gtmConversionEvent.gtmReferPath,
    gtmContentIds: gtmConversionEvent.gtmContentIds,
    gtmClickId: gtmConversionEvent.gtmClickId,
    gtmQuantcastLabel: gtmConversionEvent.gtmQuantcastLabel,
    gtmPageTopic: gtmConversionEvent.gtmPageTopic,
    gtmPageVertical: gtmConversionEvent.gtmPageVertical,
  } as GTMConversionEvent);

  if (gtmEEPCEvent) {
    window.dataLayer.push({
      event: gtmEEPCEvent.event,
      gtmPrice: gtmEEPCEvent.gtmPrice,
    } as GTMEEPCEvent);
  }

  return null;
};

export default InitializeGtm;
